import request from '@/utils/request'
import { getToken } from '../utils/auth'
// 获取客服信息
export function getsipinfo () {
  return request({
    url: '/getsipinfo',
    method: 'post',
    params: { token: getToken() }
  })
}
// 坐席上线时间
export function siponline (data) {
  return request({
    url: '/siponline',
    method: 'post',
    params: { token: getToken() },
    data
  })
}
// 坐席下线时间
export function sipoffline (data) {
  return request({
    url: '/sipoffline',
    method: 'post',
    params: { token: getToken() },
    data
  })
}
// 更新电话记录
export function updatecalllist (data) {
  return request({
    url: '/updatecalllist',
    method: 'post',
    params: { token: getToken() },
    data
  })
}



// WEBPACK FOOTER //
// ./src/api/csdsip.js